import React from 'react';
import ArrayHelper from 'foundation/array-helper';
import { getRoundById } from 'general/js/helpers';
import CustomEventLeaderboardRows from './custom-event-leaderboard-rows';

const CustomEventLeaderboardTable = ({
    scoringCourse,
    currentRound,
    players,
    options,
    isPointsBased
}) => {
    const scoringCourseRound = getRoundById(scoringCourse.courseRounds, 1);

    if (!scoringCourseRound || ArrayHelper.isEmpty(scoringCourseRound.holePars)) return null;

    return (
        <div className="custom-event-leaderboard__table">
            <CustomEventLeaderboardRows
                options={options}
                scoringCourseRound={scoringCourseRound}
                currentRound={currentRound}
                players={players}
                isPointsBased={isPointsBased}
            />
        </div>
    );
};

export default CustomEventLeaderboardTable;
